import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

/**
 * The invoice's own row, under the purchase's actions rather than among them.
 *
 * Separate because the two are different questions: the buttons above are about the sessions
 * a patient bought, and this is about the piece of paper the clinic owes them. Mixing them
 * puts "Emit invoice" next to "Cancel" on a phone, which is not a pair to sit side by side.
 */
export const invoiceRowStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
    flexWrap: 'wrap',
    mt: 1,
};

/** The provider's own words for a failure, which is what the therapist can act on. */
export const errorTextStyles: SxProps<Theme> = {
    color: 'error.main',
    // Takes the whole row so a long Romanian sentence does not squeeze the retry button
    // down to two characters wide.
    flexBasis: '100%',
};

export const hintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    flexBasis: '100%',
};

/** The receipt, shown as large as the dialog allows without overflowing it. */
export const receiptImageStyles: SxProps<Theme> = {
    display: 'block',
    width: '100%',
    height: 'auto',
    maxHeight: '70vh',
    objectFit: 'contain',
};
